import { Backdrop } from '@mui/material';
import type { BackdropProps } from '@mui/material/Backdrop';
import { forwardRef, type Ref, type SyntheticEvent } from 'react';

export type ModalCloseReason = 'backdropClick' | 'escapeKeyDown';

export const NonClosableBackdrop = forwardRef(function NonClosableBackdrop(props: BackdropProps, ref: Ref<unknown>) {
  const { onClick: _onClick, ...rest } = props;

  return <Backdrop ref={ref} {...rest} />;
});

export function shouldIgnoreModalClose(reason?: string): reason is ModalCloseReason {
  return reason === 'backdropClick' || reason === 'escapeKeyDown';
}

export function guardModalClose<TEvent = SyntheticEvent>(handler?: (event: TEvent, reason?: string) => void) {
  return (event: TEvent, reason?: string) => {
    if (shouldIgnoreModalClose(reason)) {
      return;
    }

    handler?.(event, reason);
  };
}